import { render } from "./list-lead.vue?vue&type=template&id=029f0bd6"
import script from "./list-lead.vue?vue&type=script&lang=js"
export * from "./list-lead.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__